import { JSX, Show, splitProps } from 'solid-js';
import cx from 'classnames';
import Icon, { IconName } from './Icon';

const info: TypeConf = {
  bg: 'bg-success/10',
  fg: 'text-success',
  icon: 'Attention',
};
const warning: TypeConf = {
  bg: 'bg-warning/10',
  fg: 'text-warning',
  icon: 'Caution',
};
const error: TypeConf = {
  bg: 'bg-error/10',
  fg: 'text-error',
  icon: 'Error',
};
const types = {
  info,
  warning,
  error,
};

export default function Notice(props: NoticeProps) {
  const [, others] = splitProps(props, ['class', 'type', 'children']);
  const type = (type?: Types) => type && types[type];

  return (
    <div
      {...others}
      class={cx(
        'flex rounded-xl p-2 text-secondary',
        type(props.type)?.bg || 'bg-success/10',
        props.class
      )}
    >
      <Show when={type(props.type)}>
        {(it) => (
          <Icon
            class={cx('-mt-0.5 mr-1.5 h-6 w-6 flex-none', it().fg)}
            name={it().icon}
          />
        )}
      </Show>
      {props.children}
    </div>
  );
}

type Types = keyof typeof types;
type TypeConf = {
  bg: string;
  fg: string;
  icon: IconName;
};

interface NoticeProps extends JSX.HTMLAttributes<HTMLDivElement> {
  type?: Types;
}
